import * as React from 'react'

const Wrapper = ({ children }) => <React.Fragment>{children}</React.Fragment>
export default Wrapper
